import React from 'react';
import { ExampleImg } from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Container, 
} from '@Main/elements';
import { DownloadFile, Margin, P } from '@helpers';
import { getImage } from "gatsby-plugin-image";

export const Merch = ({getPng, getZip, t}) => {
    return (
      <PageWrapper darkMode={false}>
        <Container paddingTop='99px' marginLeft='102px'>
          <P weight='400' size='25px' height='40px'>{t("Documentation and merchandise branding")}</P>
          <FlexDiv>
            <Margin maxWidth="308px" marginTop="45px" marginRight="41px">
              <P weight='400' size='15px' height='30px' marginBottom="30px">
                {t("This is a set of corporate style media required for daily company activities for intra-corporate applications, partners and clients.")}
              </P>
              <DownloadFile fileName='template_documents' file={getZip("template_documents")}/>
            </Margin>
            <Margin marginTop="50px"><ExampleImg image={getImage(getPng('merch'))} alt="merch" width="391px" height="231px"/></Margin>
          </FlexDiv>
        </Container>
        <Container paddingTop='92px' marginLeft='102px' paddingBottom='136px'>
          <FlexDiv>
            <Margin maxWidth="308px" marginTop="45px" marginRight="41px">
              <P weight='400' size='15px' height='30px' marginBottom="30px">
              {t("The design of any merchandise must be closely connected with the company's identity and contain corporate colors, logos, or elements thereof (subject to all norms of acceptable placement).")}
              </P>
            </Margin>
            <ExampleImg image={getImage(getPng('t-shirt_1'))} alt='t-shirt' width="195px"/>
            <ExampleImg image={getImage(getPng('t-shirt_2'))} alt='t-shirt' width="196px"/>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};
